import React, { Component } from 'react'
import DefaultLayout from '../../../components/layout/DefaultLayout'
import moment from 'moment'
import Router from 'next/router'
import { FaExternalLinkAlt } from 'react-icons/fa'
import { assetPrefix } from 'config/env_config'
import { PAGE_URL, WEEKDAYS } from 'utils'
import MODAL from 'utils/modals'
import withRootContext from 'context/withRootContextHOC'
import { ServiceScheduleContextProvider } from '../../../context/serviceScheduleContext'

import { getCheckRated, setDeclineRating, getUserSchedulings } from 'services/schedulingService'
import { redirectService } from 'services/redirectService'
import { getAllMyPets } from 'services/petService'
import ComingSoon from 'static/icons/coming-soon.svg'
import ServiceIcon from 'static/icons/service-icon.svg'
import SeloRJ from 'static/images/selo-rj.svg'
import WarningModal from 'components/warningModal'
import InfoModal from 'components/infoModal'
import ThermPetAnjo from 'components/modal/ThermPetAnjo'
import SatisfactionSurveyModal from 'components/satisfactionSurvey/SatisfactionSurveyModal'
import SchedulingCard from 'src/components/schedulingCard'
import LastSchedulingsCarousel from 'src/components/lastSchedulingsCarousel'
import * as S from 'src/styles/pages/Welcome'
import Tag from 'src/components/tag'
import Button from 'src/components/button'
import Highlight from 'src/components/highlight'
import TabLayout from 'src/components/tabLayout'
import { MobileOnly, DesktopOnly } from 'components/styled'

// A abreviação original vem toda em lower case
moment.updateLocale('pt-BR', { dayNamesShort: WEEKDAYS, weekdaysShort: WEEKDAYS })
const ICON_DIR = `${assetPrefix}/static/icons`
const PETANJO_BASE_SITE = process.env.PETANJO_BASE_SITE
const allStatus = ['IN_PROGRESS', 'SCHEDULED', 'FINISHED', 'CANCELLED', 'DESIST', 'PAYMENT_PENDING', 'NO_SHOW']
class WelcomeSchedule extends Component {
  static Layout = DefaultLayout
  constructor (props) {
    super(props)
    this.state = {
      schedulingData: [],
      schedulingTotal: 0,
      skip: 0,
      petsData: [],
      serviceData: [
        { id: 'BANHO_TOSA', name: 'Banho & Tosa', description: 'Seu pet sempre limpinho e bem cuidado.', blackFriday: true, blackFridayDiscount: '10% Off', photo: { src: `${ICON_DIR}/service-bath.svg` }, blackStamp: true, order: 1 },
        { id: 'CLINICA_VET', name: 'Veterinário', description: 'A saúde do seu melhor amigo em boas mãos.', photo: { src: `${ICON_DIR}/service-vet.svg` }, rjOnly: false, order: 2 },
        { id: 'PETSITTER', name: 'Pet Sitter', description: 'Um Anjo vai até sua casa para cuidar do seu pet.', blackFriday: true, blackFridayDiscount: '15% Off', photo: { src: `${ICON_DIR}/service-pet-sitter.svg` }, petAnjo: true, redirect: `${process.env.PETANJO_BASE_SITE}/petsitter`, order: 3 },
        { id: 'HOSPEDAGEM', name: 'Hospedagem Pet', description: 'Hospedagem em ambiente familiar na casa do Anjo.', blackFriday: true, blackFridayDiscount: '15% Off', photo: { src: `${ICON_DIR}/service-hotel.svg` }, petAnjo: true, redirect: `${process.env.PETANJO_BASE_SITE}/hospedagem`, order: 4 },
        { id: 'DOGWALKER', name: 'Dog Walker', description: 'Passeios educativos para o seu pet ter mais qualidade de vida.', blackFriday: true, blackFridayDiscount: '15% Off', photo: { src: `${ICON_DIR}/service-dog-walker.svg` }, petAnjo: true, redirect: `${process.env.PETANJO_BASE_SITE}/dogwalker`, order: 5 },
        { id: 'DAYCARE', name: 'Creche Pet', description: 'Ambiente familiar, muito cuidado, amor e brincadeiras.', blackFriday: true, blackFridayDiscount: '15% Off', photo: { src: `${ICON_DIR}/service-day-care.svg` }, petAnjo: true, redirect: `${process.env.PETANJO_BASE_SITE}/daycare`, order: 6 },
        { id: 'ADESTRADOR', name: 'Adestramento', description: 'Um Anjo ensina seu pet através de comandos e petiscos.', blackFriday: true, blackFridayDiscount: '15% Off', photo: { src: `${ICON_DIR}/service-training.svg` }, petAnjo: true, redirect: `${process.env.PETANJO_BASE_SITE}/adestramento`, order: 7 },
        { id: 'ADOCAO', name: 'Adoção', description: 'O novo membro da sua família está te esperando.', photo: { src: `${ICON_DIR}/service-adoption.svg` }, redirect: 'https://cobasicuida.com.br/adocao', isBlank: true, external: true, order: 8 }
      ],
      statusData: {
        SCHEDULED: { description: 'Pagamento na recepção', color: 'var(--dark-mint-green)' },
        FINISHED: { description: 'Serviço realizado', icon: `${ICON_DIR}/check-circle.svg`, color: 'var(--teal-green)', editTooltip: 'Este agendamento foi realizado e não pode ser editado' },
        CANCELLED: { description: 'Serviço cancelado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi cancelado e não pode ser editado.' },
        DESIST: { description: 'Serviço cancelado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi cancelado e não pode ser editado.' },
        IN_PROGRESS: { description: 'Serviço em andamento', color: 'var(--dark-mint-green)', editTooltip: 'Este agendamento está em andamento e não pode ser editado.' },
        'IN_PROGRESS.PAYMENT_AUTHORIZED': { description: 'Serviço em andamento', icon: `${ICON_DIR}/credit-card-check.svg`, color: 'var(--dark-mint-green)', editTooltip: 'Este agendamento está em andamento e não pode ser editado.' },
        'SCHEDULED.PAYMENT_PENDING': { description: 'Serviço pendente de pagamento', icon: `${ICON_DIR}/credit-card-sync-outline.svg`, color: 'var(--golden-rod)' },
        'SCHEDULED.PAYMENT_PROCESSING': { description: 'Pagamento em análise', icon: `${ICON_DIR}/credit-card-sync-outline.svg`, color: 'var(--golden-rod)', editTooltip: 'Após confirmação do pagamento, este botão estará disponível para realizar a edição do agendamento.' },
        'SCHEDULED.PAYMENT_AUTHORIZED': { description: 'Pagamento aprovado', icon: `${ICON_DIR}/credit-card-check.svg`, color: 'var(--dark-mint-green)' },
        'CANCELLED.PAYMENT_UNFINISHED': { description: 'Pagamento não pôde ser realizado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi cancelado e não pode ser editado.' },
        'CANCELLED.PAYMENT_ERROR': { description: 'Pagamento não pôde ser realizado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi cancelado e não pode ser editado.' },
        'CANCELLED.PAYMENT_CHARGEBACK': { description: 'Serviço cancelado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi cancelado e não pode ser editado.' },
        'DESIST.PAYMENT_CHARGEBACK': { description: 'Serviço cancelado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi cancelado e não pode ser editado.' },
        'FINISHED.PAYMENT_AUTHORIZED': { description: 'Serviço realizado', icon: `${ICON_DIR}/check-circle.svg`, color: 'var(--teal-green)', editTooltip: 'Este agendamento foi realizado e não pode ser editado.' },
        'FINISHED.PAYMENT_ERROR': { description: 'Pagamento não pôde ser realizado', icon: `${ICON_DIR}/close-circle.svg`, color: 'var(--the-red)', editTooltip: 'Este agendamento foi finalizado e não pode ser editado.' }
      },
      iconsForType: {
        breeds: {
          DOG: `${ICON_DIR}/dog.svg`,
          CAT: `${ICON_DIR}/cat.svg`,
          FERRET: `${ICON_DIR}/ferret.svg`,
          RABBIT: `${ICON_DIR}/rabbit.svg`,
          PIGGY_INDIAN: `${ICON_DIR}/guinea-pig.svg`
        }
      },
      query: { filter: 'all', status: allStatus },
      loadingSchedulings: false,
      showTermsModal: true,
      infoModal: undefined,
      modal: undefined,
      tooltip: undefined,
      isAgendaTabActive: false,
      openThermAccept: false,
      serviceToRedirect: '',
      loadingServiceToRedirect: false,
      checkRated: { showModal: false }
    }
    this.handleRetrieveSchedulingData = this.handleRetrieveSchedulingData.bind(this)
  }

  async handleRetrievePetsData () {
    const { context } = this.props
    context.showLoader(context.isMobile)
    try {
      const petsList = await getAllMyPets()
      if (petsList) {
        this.setState({ petsData: petsList })
      }
    } catch (error) {
      this.setState({ petsData: [] })
      console.error(error)
    } finally {
      context.hideLoader()
    }
  }

  async handleRetrieveSchedulingData () {
    const { context } = this.props
    context.showLoader()
    const schedulingData = (context.firstName && await getUserSchedulings({
      status: this.state.query.status,
      skip: this.state.skip,
      limit: 10
    })) || []

    this.setState({
      schedulingData: [...this.state.schedulingData, ...schedulingData.schedulings],
      schedulingTotal: schedulingData.totalItems,
      skip: this.state.skip + 10
    }, context.hideLoader)
  }

  async retrieveCheckRate () {
    const { context } = this.props
    context.showLoader(context.isMobile)

    const checkRated = (context.firstName && await getCheckRated()) || {}

    this.setState({
      checkRated
    }, context.hideLoader)
  }

  async componentDidMount () {
    this.clearModalState()
    const { context, query } = this.props
    const isAcceptedTherm = window.localStorage.getItem('thermAccepted') || 'false'
    this.setState({ isAcceptedTherm })

    // só deve chamar se usuário estiver logado
    if (context.firstName) {
      this.handleRetrievePetsData()
      await this.handleRetrieveSchedulingData()
      this.retrieveCheckRate()
    }
    if (query?.tab) this.handleTabChange(query.tab)
    if (query?.rescheduled) this.handleReschedulingSuccessModal()
    if (query?.canceled) this.handleSchedulingCanceledModal()
  }

  async componentDidUpdate (prevProps, prevState) {
    const { context, query } = this.props
    const isAcceptedTherm = window.localStorage.getItem('thermAccepted') || 'false'

    if (query.tab !== prevProps.query.tab) this.handleTabChange(query.tab)
    // se usuario fez o login
    if ((context.firstName !== prevProps.context.firstName)) {
      // e não tiver a tab de servicos ou agenda ativado, irá chamar o serviço default que é minha agenda
      this.handleRetrievePetsData()
      await this.handleRetrieveSchedulingData()
      this.retrieveCheckRate()
    }
    if (query?.canceled !== prevProps.query.canceled) {
      this.handleRetrieveSchedulingData()
    }
    if (isAcceptedTherm !== prevState.isAcceptedTherm) {
      this.setState({ isAcceptedTherm })
    }
  }

  clearModalState () {
    let state = window.localStorage.getItem('schedulingState')

    if (state) {
      state = JSON.parse(state)
      delete state.modal
      window.localStorage.setItem('schedulingState', JSON.stringify(state))
    }
  }

  handleTabChange (tab) {
    this.setState({
      isAgendaTabActive: tab === 'agenda'
    })
  }

  handleToggleThermAccept = () => this.setState({
    openThermAccept: !this.state.openThermAccept
  })

  canRedirectWhenThermIsAccepted = async (isThermAccepted, pageToRedirect) => {
    const data = await redirectService(isThermAccepted, pageToRedirect)
    this.props.context.hideLoader()
    return window.open(data.redirect, '_self')
  }

  handleRedirectPetAnjo = async (isThermAccepted = false) => {
    try {
      if (!isThermAccepted) return window.open(`${PETANJO_BASE_SITE}/clientes/entrar`, '_self')

      this.setState({
        loadingServiceToRedirect: true
      })
      window.localStorage.setItem('thermAccepted', isThermAccepted)
      return await this.canRedirectWhenThermIsAccepted(isThermAccepted, this.state.serviceToRedirect || PETANJO_BASE_SITE)
    } catch (error) {
      window.open(this.state.serviceToRedirect, '_self')
    } finally {
      this.setState({
        loadingServiceToRedirect: false
      })

      this.handleToggleThermAccept()
    }
  }

  handleGetLastSchedulingId = () => {
    const { checkRated } = this.state

    const lastSchedulingId = checkRated.scheduling.id
    return lastSchedulingId
  }

  handleRedirectToSatisfactionSurvey = () => {
    const schedulingId = this.handleGetLastSchedulingId()

    Router.push({
      pathname: `${PAGE_URL.SATISFACTION_SURVEY}/${schedulingId}`
    })
  }

  handleRefuseOrCloseSatisfactionSurveyModal = async () => {
    const schedulingId = this.handleGetLastSchedulingId()
    await setDeclineRating(schedulingId)
    this.setState({
      checkRated: { ...this.state.checkRated, showModal: false }
    })
  }

  handleSelectService = async ({ id, redirect, isBlank, isPetAnjo, external }) => {
    const target = isBlank ? '_blank' : '_self'
    const { context } = this.props
    const LOGGED_IN = context.firstName
    const REACT_NATIVE = context.isReactNative
    const goToSchedule = () => {
      const firstLogin = !window?.localStorage?.getItem('showDiary')

      if (!LOGGED_IN) context.toggleModalSheet({}, true)
      this.redirectToService({
        id,
        isPetAnjo,
        redirect,
        ...((firstLogin && !LOGGED_IN) && { showDiary: true })
      })
      context.hideLoader()
    }
    if (!redirect && !LOGGED_IN && !REACT_NATIVE && !external) {
      context.toggleModalSheet(MODAL.LOGIN_MODAL({ onCancel: goToSchedule, callback: goToSchedule }))
      return
    }
    context.showLoader()

    if ((redirect && !LOGGED_IN) || external) {
      context.hideLoader()
      return window.open(redirect, target)
    }

    goToSchedule()
  }

  redirectToService = async ({ id, isPetAnjo, redirect, showDiary }) => {
    const { context } = this.props

    if (isPetAnjo) {
      const isThermAccepted = window.localStorage.getItem('thermAccepted')

      if (isThermAccepted === 'true') {
        context.hideLoader()
        const IS_THERM_ACCEPTED = true
        return await this.canRedirectWhenThermIsAccepted(IS_THERM_ACCEPTED, redirect)
      }

      return this.setState({
        serviceToRedirect: redirect
      }, () => {
        context.hideLoader()
        this.handleToggleThermAccept()
      })
    }

    window.localStorage.removeItem('category')
    window.localStorage.removeItem('schedulingState')
    window.localStorage.removeItem('paymentState')

    if (showDiary) {
      window.localStorage.setItem('showDiary', true)
    }

    const query = {
      category: id,
      ...(showDiary && { showDiary })
    }

    Router.push({
      pathname: PAGE_URL.SCHEDULING_PET_AND_SERVICES,
      query
    })
  }

  handleFilterSelectSchedulings = async (filter) => {
    const { context } = this.props

    let status, payStatus

    if (filter) {
      switch (filter) {
        case 'finished':
          status = ['FINISHED']
          break
        case 'active':
          status = ['IN_PROGRESS', 'SCHEDULED', 'PAYMENT_PENDING']
          break
        case 'cancelled':
          status = ['CANCELLED', 'DESIST', 'NO_SHOW']
          break
        case 'all':
          status = allStatus
          break
        default:
          break
      }

      context.showLoader(context.isMobile)

      const schedulingData = await getUserSchedulings({ status, payStatus, skip: 0, limit: 10 })
      this.setState({
        skip: 10,
        ...(schedulingData.schedulings && { schedulingData: [...schedulingData.schedulings] }),
        schedulingTotal: schedulingData.totalItems,
        query: { filter, status }
      })

      context.hideLoader()
    }
  }

  handleModalChange = (newModal) => {
    this.setState(newModal)
  }

  handleReschedulingSuccessModal = () => {
    this.setState({
      modal: {
        showButtons: false,
        title: <S.ModalTitle>Seu serviço foi reagendado com <br />sucesso!</S.ModalTitle>,
        icon: `${assetPrefix}/static/icons/check-green-circle.svg`,
        cancelLabel: 'Fechar',
        showClose: false
      }
    })
  }

  handleSchedulingCanceledModal = () => {
    this.setState({
      modal: {
        showButtons: false,
        title: <S.ModalTitle>Seu serviço foi cancelado com sucesso!</S.ModalTitle>,
        icon: `${assetPrefix}/static/icons/hyper-check.svg`,
        cancelLabel: 'Fechar',
        noPadding: true,
        showClose: false
      }
    })
  }

  render () {
    const { context: { firstName: user, toggleModalSheet, showLoader } } = this.props
    const { serviceData, schedulingData, modal, infoModal, isAgendaTabActive, openThermAccept, loadingServiceToRedirect, checkRated, isAcceptedTherm, schedulingTotal } = this.state
    const filterOptions = [
      { value: 'all', label: 'Todos' },
      { value: 'active', label: 'Ativos', unformatted: 'ativo' },
      { value: 'cancelled', label: 'Cancelados', unformatted: 'cancelado' },
      { value: 'finished', label: 'Realizados', unformatted: 'realizado' }
    ]

    const schedulings = schedulingData && schedulingData.length ? (
      <>
        {schedulingData.map(({ date, pet, professional, service, additionalServices, partner, status, payStatus, obs, id, rated, externalCoupon, campaign, payments }) => {
          const localizedDate = moment(date).locale('pt-BR')
          const time = localizedDate.format('HH:mm')
          const day = localizedDate.format('DD/MM/YY - ddd')
          const additionalServicesScheduled = additionalServices?.map(service => service.name).join(', ')
          const professionalName = `${professional.name.split('CNPJ')[0]}`
          const professionalCNPJ = `${professional.cnpj}`
          const partnerPhone = partner.phone
          const localization = `${partner.fantasyName} - ${partner.address}`
          const petPhoto = this.state.petsData ? this.state.petsData.find(petData => petData.id === pet.id)?.photo : ''
          const hasOnlinePayment = payments?.online

          const schedulingInfo = {
            id,
            pet,
            petPhoto,
            day,
            time,
            additionalServices: additionalServicesScheduled,
            professionalId: professional.id,
            professionalName,
            professionalCNPJ,
            partnerId: partner.id,
            partnerFantasyName: partner.fantasyName,
            partner: localization,
            partnerPhone,
            payStatus,
            obs,
            coupon: externalCoupon,
            status,
            rated,
            service,
            campaign,
            filterStatus: this.state.query.filter,
            hasOnlinePayment,
            handleSchedulingCanceledModal: this.handleSchedulingCanceledModal,
            handleFilterSelectSchedulings: this.handleFilterSelectSchedulings
          }

          return (
            <ServiceScheduleContextProvider key={id}>
              <SchedulingCard
                schedulingInfo={schedulingInfo}
                id={id}
              />
            </ServiceScheduleContextProvider>
          )
        })}
      </>
    ) : (
      <S.ScheduleText data-test='scheduling-empty'>
        Assim que você realizar um serviço, ele ficará registrado nesta área. <br /> Confira as opções de <strong><ServiceIcon /> Serviços</strong> e agende com os nossos parceiros Anjos.
      </S.ScheduleText>
    )

    const title = (
      <>
        <S.Text>Agende o serviço com os Anjos parceiros.</S.Text>
      </>
    )

    const scheduleList = (
      <S.Schedulings active>
        <S.SchedulingTitle>Agendamentos</S.SchedulingTitle>
        {(schedulingData.length > 0 || this.state.query.filter !== 'all') && (
          <S.SchedulingStatuses>
            {filterOptions.map(option => {
              const isSelected = this.state.query.filter === option.value
              return (
                <Tag
                  key={option.value}
                  selected={isSelected}
                  onClick={() => this.handleFilterSelectSchedulings(option.value)}
                >
                  {option.label}
                </Tag>
              )
            })}
          </S.SchedulingStatuses>
        )}
        <S.SchedulingsList>
          {schedulings}
        </S.SchedulingsList>
      </S.Schedulings>
    )

    const loggedOutScheduleWarning = (
      <S.Schedulings active>
        <S.SchedulingTitle>Agendamentos</S.SchedulingTitle>
        <S.ScheduleText>Para ver seu histórico de agendamentos, você precisa estar logado.</S.ScheduleText>
        <Button onClick={() => toggleModalSheet(MODAL.LOGIN_MODAL({ onCancel: toggleModalSheet, callback: toggleModalSheet }))} margin='0' theme='secondary' label='Acessar conta' height='32px' />
      </S.Schedulings>
    )

    const renderPetAnjoLink = () => {
      const handleClickSeeHere = () => {
        if (isAcceptedTherm === 'false' || !isAcceptedTherm) this.handleToggleThermAccept()
        else {
          showLoader()
          this.canRedirectWhenThermIsAccepted(isAcceptedTherm, '/')
        }
      }

      if (user) return <button onClick={() => handleClickSeeHere()}>veja aqui</button>

      return <a href={`${PETANJO_BASE_SITE}/clientes/entrar`}>veja aqui</a>
    }

    const renderSchedulings = (user) => {
      const handleGotoSchedulingHome = () => {
        Router.push({
          pathname: PAGE_URL.SCHEDULING_INDEX
        })
      }

      return (
        <S.SchedulingTab>
          <S.SchedulingTitle main>Minha agenda</S.SchedulingTitle>
          <S.PetAnjoInfo>
            Para acompanhar os serviços de <b>Dog Walker, Pet Sitter, Hospedagem Pet, Creche Pet e Adestramento</b>, <FaExternalLinkAlt size={12} />  {renderPetAnjoLink()} e visualize o status em <b>Meus pedidos</b>.
          </S.PetAnjoInfo>
          <MobileOnly>
            <Button onClick={() => handleGotoSchedulingHome()} height='40px' margin='24px 0 0 0' label='Novo agendamento' />
          </MobileOnly>
          {user ? scheduleList : loggedOutScheduleWarning}
          {(schedulingTotal && schedulingData) ? (
            <S.PaginationCount>
              {`${schedulingData.length} de ${schedulingTotal} agendamento${schedulingTotal > 1 ? 's' : ''}`}
            </S.PaginationCount>
          ) : <></>}
          {schedulingTotal > 10 &&
            <S.WrapperButton>
              <S.LoadMore disabled={schedulingData.length === schedulingTotal} type='button' onClick={() => this.handleRetrieveSchedulingData()}>Carregar mais</S.LoadMore>
            </S.WrapperButton>}
        </S.SchedulingTab>
      )
    }

    return (
      <S.Container>
        <S.BannerContainer>
          <MobileOnly>
            <S.BannerPlaceholder />
          </MobileOnly>
        </S.BannerContainer>
        <TabLayout />
        {
          isAgendaTabActive && renderSchedulings(user)
        }
        {!isAgendaTabActive &&
          <S.ServicesContainer id='servicos'>
            <DesktopOnly>
              <S.BannerPlaceholder />
            </DesktopOnly>

            {this.state.petsData.length > 0 && <LastSchedulingsCarousel petsData={this.state.petsData} />}

            <S.PageTitleContainer>
              {title}
            </S.PageTitleContainer>

            <S.ServiceItemsContainer>
              {serviceData && serviceData.map(service => (
                <S.ButtonSize
                  order={service.order}
                  key={service.name}
                  opacity={service.opacity}
                  disabled={service.disabled}
                  data-test={`button-${service.id.toLowerCase().replace('_', '-')}`}
                >
                  <S.Button onClick={() => this.handleSelectService({ id: service.id, redirect: service.redirect, isBlank: service.isBlank, isPetAnjo: service.petAnjo, external: service.external })} className='ServiceButton'>
                    <img {...service.photo} />
                    <S.ButtonTextContainer>
                      <S.ServiceName>{service.name} {!!service.new && <S.ServiceFlag>Novo</S.ServiceFlag>}</S.ServiceName>
                      <S.ServiceDescription>{service.description}</S.ServiceDescription>
                      {
                        service.label &&
                          <Highlight>{service.label}</Highlight>
                      }
                    </S.ButtonTextContainer>
                  </S.Button>
                  {(service.disabled || service.rjOnly) && (
                    <S.Label transform={service.rjOnly ? 'scale(1.1)' : 'scale(.9)'}>
                      {service.rjOnly ? <SeloRJ /> : <ComingSoon />}
                    </S.Label>
                  )}
                </S.ButtonSize>
              ))}
            </S.ServiceItemsContainer>
          </S.ServicesContainer>}
        <WarningModal
          visible={!!modal}
          cancelLabel={modal?.cancelLabel}
          confirmLabel={modal?.confirmLabel}
          showClose={modal?.showClose}
          outlineCancelButton={modal?.outlineCancelButton}
          type={modal?.type}
          title={modal?.title}
          subtitle={modal?.subtitle}
          onCancel={() => this.handleModalChange({ modal: undefined })}
          onConfirm={modal?.onConfirm}
          icon={modal?.icon}
          iconSize={modal?.iconSize}
          noPadding={modal?.noPadding}
          dataTest='modal-warning-welcome'
          modalWidth={modal?.modalWidth}
          modalHeight={modal?.modalHeight}
        >
          {modal?.body}
        </WarningModal>

        <InfoModal
          visible={!!infoModal}
          cancelLabel={infoModal?.cancelLabel}
          confirmLabel={infoModal?.confirmLabel}
          showClose={infoModal?.showClose}
          title={infoModal?.title}
          subtitle={infoModal?.subtitle}
          onCancel={() => this.handleModalChange({ infoModal: undefined })}
          icon={infoModal?.icon}
          iconSize={infoModal?.iconSize}
          dataTest='modal-warning-welcome'
          modalWidth={infoModal?.modalWidth}
          modalHeight={infoModal?.modalHeight}
        >
          {infoModal?.body}
        </InfoModal>

        <ThermPetAnjo
          show={openThermAccept}
          onHandleClose={this.handleToggleThermAccept}
          onHandleAcceptTherm={async (accepted) => await this.handleRedirectPetAnjo(accepted)}
          loading={loadingServiceToRedirect}
        />
        <SatisfactionSurveyModal
          show={checkRated.showModal}
          onHandleClose={this.handleRefuseOrCloseSatisfactionSurveyModal}
          onHandleRate={this.handleRedirectToSatisfactionSurvey}
          petType={checkRated.scheduling?.pet.breed.type}
        />
      </S.Container>
    )
  }
}

WelcomeSchedule.getInitialProps = ({ query, context }) => {
  return { query, context }
}

export default withRootContext(WelcomeSchedule)
